import { css, styled } from 'styled-components';

import { layoutHeaderMobileLinksHeight } from '#/layouts/Layout/Header/layoutHeaderConstants';
import { scrolledDownZeroVar } from '#/theme/scrolled';
import { colors, cssBreakpoints, gutterWidth, transition } from '#/theme/theme';

export const LayoutHeaderSearchSubmenuHolder = styled.div<{
  $hideMobileHeaderOnScroll: boolean;
  $withScrolledTransition: boolean;
}>`
  display: flex;
  flex-direction: column;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    ${(props) =>
      props.$hideMobileHeaderOnScroll
        ? css`
            transition: ${props.$withScrolledTransition &&
            `padding-top ${transition}`};
            padding-top: calc(
              ${[layoutHeaderMobileLinksHeight]}px *
                var(${scrolledDownZeroVar}, 1)
            );
          `
        : css`
            padding-top: ${layoutHeaderMobileLinksHeight}px;
          `};
  }
`;

export const LayoutHeaderDesktopSearchHolder = styled.div`
  padding: 16px ${gutterWidth / 2}px;
  background-color: ${colors.white};
  border-top: 1px solid ${colors.selectionGrey};

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
